// src/app/components/view-token-modal/view-token-modal.component.ts
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Token} from "../../../../../../../services/token.service";


@Component({
  selector: 'app-view-token-modal',
  styleUrls: ['./view-token-modal.component.scss'],
  templateUrl: './view-token-modal.component.html',
})
export class ViewTokenModalComponent  {
  @Input() public token!: any;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }
}
